import builder from '../builder';
import CreditCardCheck from '../../streamline-icons/bold/credit-card-check.svg';

export default builder('IconCreditCardCheckBold', CreditCardCheck);
